import React, { Component } from 'react';
import { arrayOf, shape, string } from 'prop-types';

import Link from '../components/WrappedLink';

export default class AddButton extends Component {
  static propTypes = {
    choices: arrayOf(
      shape({
        label: string,
        path: string,
      }),
    ),
    path: string,
  };

  state = {
    open: false,
  };

  render() {
    if (!this.props.choices) {
      return (
        <Link to={this.props.path} className="button is-success">
          <span className="icon is-small">
            <i className="mi mi-add-circle" />
          </span>
          <span>Aggiungi</span>
        </Link>
      );
    }
    return (
      <div className={`dropdown ${this.state.open ? 'is-active' : ''}`}>
        <div className="dropdown-trigger">
          <button
            className="button is-info"
            aria-haspopup="true"
            aria-controls="dropdown-menu"
            onClick={() => this.setState({ open: true })}
            // @TODO: review this setTimeout
            onBlur={() => setTimeout(() => this.setState({ open: false }), 300)}
          >
            <span className="icon is-small">
              <i className="mi mi-add-circle" />
            </span>
            <span>Aggiungi</span>
            <span className="icon is-small">
              <i className="mi mi-keyboard-arrow-down" aria-hidden="true" />
            </span>
          </button>
        </div>
        <div className="dropdown-menu" id="dropdown-menu" role="menu">
          <div className="dropdown-content">
            {this.props.choices.map(({ label, path }) => (
              <Link key={path} to={path} className="dropdown-item">
                {label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

AddButton.displayName = 'AddButton';
